module.exports = __webpack_public_path__ + "img/send_un.ea72ab2e.svg";